import { createFileRoute, Link } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import LayeredButton from '~/components/LayeredButton';
import { pressData } from '~/data/press';
import { PageSection } from '~/routes/__root';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/press')({
  component: Press,
});

function Press() {
  const locale = useStore(langStore, s => s);
  const pressPrefix = {
    HU: 'Sajtómegjelenések',
    EN: 'Press releases',
    RS: 'Saopštenja za štampu',
  };

  const pressLinks = [
    { locale: 'HU', link: 'https://forms.gle/KwBcREVazMNTx2zY7', text: 'Sajtóakkreditáció' },
    { locale: 'EN', link: '/contact', text: 'Write us a mail' },
    { locale: 'RS', link: 'https://forms.gle/uUhSNqxK17yNUodi6', text: 'Press akreditacija' },
  ];

  const sortedPress = [
    ...pressData.filter(p => p.country === locale),
    ...pressData.filter(p => p.country !== locale),
  ];

  return (
    <PageSection width="narrow">
      <div className="mb-2 flex flex-col justify-between gap-2 lg:flex-row">
        <MarkdownBlock>
          {`# ${pressPrefix[locale]}`}
        </MarkdownBlock>
        <Link
          to={pressLinks.find(x => x.locale === locale)!.link}
          target={locale !== 'EN' ? '_blank' : ''}
          rel="noopener noreferrer"
          data-umami-event="press-accreditation"
          data-umami-event-locale={locale}
        >
          <LayeredButton text={pressLinks.find(x => x.locale === locale)!.text} className="h-1/2 align-bottom lg:h-10 ">
          </LayeredButton>
        </Link>
      </div>
      <div>
        <div className="border-orange border-2 p-2 md:p-10">
          {sortedPress.map((item, idx) => (
            <div key={item.link}>
              <div className="mb-2 flex flex-col justify-between gap-2">
                <MarkdownBlock
                  renderers={{
                    a: ({ node, ...props }) => (
                      <a
                        className="text-blackish text-sm break-words hover:underline lg:text-base"
                        href={props.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-umami-event="press"
                        data-umami-event-link={props.href}
                        {...props}
                      >
                        {props.children}
                      </a>
                    ),
                  }}
                >
                  {`[${item.title}](${item.link})`}
                </MarkdownBlock>
                <div className="text-left text-xs text-wrap lg:text-sm">
                  <MarkdownBlock>
                    {`**${item.outlet} (${item.country})**, *${item.date}*`}
                  </MarkdownBlock>
                </div>
              </div>
              {idx < sortedPress.length - 1
                && <hr className="border-orange my-2" />}
            </div>
          ))}
        </div>
      </div>
    </PageSection>
  );
}
